/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 支払対象期間（開始日、終了日）
 * @export
 * @interface ListOperations200ResponseItemsInnerPeriod
 */
export interface ListOperations200ResponseItemsInnerPeriod {
    /**
     * 開始日
     * @type {Date}
     * @memberof ListOperations200ResponseItemsInnerPeriod
     */
    startDate: Date;
    /**
     * 終了日
     * @type {Date}
     * @memberof ListOperations200ResponseItemsInnerPeriod
     */
    endDate: Date;
}

/**
 * Check if a given object implements the ListOperations200ResponseItemsInnerPeriod interface.
 */
export function instanceOfListOperations200ResponseItemsInnerPeriod(value: object): value is ListOperations200ResponseItemsInnerPeriod {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function ListOperations200ResponseItemsInnerPeriodFromJSON(json: any): ListOperations200ResponseItemsInnerPeriod {
    return ListOperations200ResponseItemsInnerPeriodFromJSONTyped(json, false);
}

export function ListOperations200ResponseItemsInnerPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOperations200ResponseItemsInnerPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
    };
}

export function ListOperations200ResponseItemsInnerPeriodToJSON(json: any): ListOperations200ResponseItemsInnerPeriod {
    return ListOperations200ResponseItemsInnerPeriodToJSONTyped(json, false);
}

export function ListOperations200ResponseItemsInnerPeriodToJSONTyped(value?: ListOperations200ResponseItemsInnerPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start_date': ((value['startDate']).toISOString().substring(0,10)),
        'end_date': ((value['endDate']).toISOString().substring(0,10)),
    };
}

